import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import { Spacer } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "visibilty"
    }}>{`Visibilty`}</h1>
    <p>{`Utility classes to toggle the visibilty of an element`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.v-hidden</Name>
        <Output mdxType="Output">visibilty: hidden;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.v-visibile</Name>
        <Output mdxType="Output">visibilty: visibile;</Output>
    </Property>
  </Reference>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`Note that `}<inlineCode parentName="p">{`v-hidden`}</inlineCode>{` hides an element, but still maintains its place in the DOM.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="flex flex-middle flex-center bg-tertiary-100">
      <div className="bg-tertiary-500 c-white h-11 w-80p v-visible" />
    </div>
  </Sandbox.Preview>
  <Spacer my={1} mdxType="Spacer" />
  <Sandbox.Preview>
    <div className="flex flex-middle flex-center bg-tertiary-100">
      <div className="bg-tertiary-500 c-white h-11 w-80p v-hidden" />
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="v-visible">...</div>
    <div className="v-hidden">...</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      